/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import {
  Button,
  IconButton,
  Img,
  MenuItem,
  useColorMode,
} from "@chakra-ui/react";
import "./NavBar.scss";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { useState } from "react";
import { Menu } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faEnvelope,
  faHeart,
  faHouse,
  faMountainSun,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { changeApplanguage } from "../../../redux/reducers/appSettingsSlice";
import useIsMobile from "../../../hooks/useIsMobile";
import Drawer from "../Drawer";
import useIsAdminMode from "../../../hooks/useIsAdminMode";

interface NavBarProps {
  translator: any;
}
function CCNavBar(props: NavBarProps) {
  const { translator } = props;
  const [baseLanguage, setBaseLanguage] = useState(
    useAppSelector((state) => state.appSettings.language)
  );
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { colorMode } = useColorMode();
  const isLightMode = colorMode === "light";
  const isMobile = useIsMobile();
  const isAdminMode = useIsAdminMode(window.location.pathname);

  const onLanguageChange = async (language) => {
    setBaseLanguage(language);
    dispatch(changeApplanguage(language));
    setLoading(false);
  };

  const navigateTo = (to: string) => {
    setIsDrawerOpen(false);
    window.scrollTo(0, 0);
    navigate(to);
  };

  return (
    !isAdminMode && (
      <header
        className={`navbar-header-pub ${
          isLightMode ? "light-shadow-pub" : "dark-shadow-pub"
        }`}
      >
        {isMobile && (
          <IconButton
            className="mobile-hamburger-btn"
            backgroundColor={"var(--chakra-colors-drawer_btn_color)"}
            aria-label=""
            icon={<FontAwesomeIcon icon={faBars} />}
            onClick={() => {
              setIsDrawerOpen(true);
            }}
          />
        )}
        {isMobile && (
          <Drawer
            isOpen={isDrawerOpen}
            showCloseButton
            placement="left"
            onClose={() => {
              setIsDrawerOpen(false);
            }}
            modalHeader={translator("Navbar.menu")}
          >
            <div className="mobile-links">
              <div className="menu-mobile-item">
                <FontAwesomeIcon icon={faHouse} />
                <Button
                  variant="primary"
                  onClick={() => {
                    navigateTo("/");
                  }}
                >
                  {translator("Navbar.home")}
                </Button>
              </div>
              <div className="menu-mobile-item">
                <FontAwesomeIcon icon={faMountainSun} />
                <Button
                  variant="primary"
                  onClick={() => {
                    navigateTo("/properties");
                  }}
                >
                  {translator("Navbar.properties")}
                </Button>
              </div>
              <div className="menu-mobile-item">
                <FontAwesomeIcon icon={faHeart} />
                <Button
                  variant="primary"
                  onClick={() => {
                    navigateTo("/favorites");
                  }}
                >
                  {translator("Global.myFavorites")}
                </Button>
              </div>
              <div className="menu-mobile-item">
                <FontAwesomeIcon icon={faUsers} />
                <Button
                  variant="primary"
                  onClick={() => {
                    navigateTo("/about");
                  }}
                >
                  {translator("Navbar.aboutUs")}
                </Button>
              </div>
              <div className="menu-mobile-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <Button
                  variant="primary"
                  onClick={() => {
                    navigateTo("/contact");
                  }}
                >
                  {translator("Navbar.contactUs")}
                </Button>
              </div>
            </div>
          </Drawer>
        )}
        <div className="links-base">
          <div className="logo">
            <a
              onClick={() => {
                navigateTo("/");
              }}
              className="logo"
            >
              <Img
                borderRadius="full"
                boxSize="72px"
                minWidth={"72px"}
                src={require("../../../assets/images/logo.png")}
              ></Img>
            </a>
          </div>
          <nav className="navbar">
            {!isMobile && (
              <div className="navbar_options">
                <Button
                  color={"#fff"}
                  fontWeight={"bold"}
                  backgroundColor={"transparent"}
                  _hover={{ backgroundColor: "transparent" }}
                  className="navbar-button"
                  onClick={() => {
                    navigateTo("/");
                  }}
                >
                  {translator("Navbar.home")}
                </Button>
                <Button
                  color={"#fff"}
                  fontWeight={"bold"}
                  backgroundColor={"transparent"}
                  _hover={{ backgroundColor: "transparent" }}
                  className="navbar-button"
                  onClick={() => {
                    navigateTo("/properties");
                  }}
                >
                  {translator("Navbar.properties")}
                </Button>
                <Button
                  color={"#fff"}
                  fontWeight={"bold"}
                  backgroundColor={"transparent"}
                  _hover={{ backgroundColor: "transparent" }}
                  className="navbar-button"
                  onClick={() => {
                    navigateTo("/about");
                  }}
                >
                  {translator("Navbar.aboutUs")}
                </Button>
                <Button
                  color={"#fff"}
                  fontWeight={"bold"}
                  backgroundColor={"transparent"}
                  _hover={{ backgroundColor: "transparent" }}
                  className="navbar-button"
                  onClick={() => {
                    navigateTo("/contact");
                  }}
                >
                  {translator("Navbar.contactUs")}
                </Button>
              </div>
            )}
          </nav>
        </div>
        <div className="user-options">
          {!isMobile && (
            <div className="language-favorites-container">
              <div className="language_selectror_container">
                <LanguageSelector
                  value={baseLanguage}
                  isLoading={loading}
                  onChange={(language) => {
                    setLoading(true);
                    onLanguageChange(language);
                  }}
                ></LanguageSelector>
              </div>
              <Button
                className="favorites-navbar-button"
                rightIcon={<FontAwesomeIcon icon={faHeart} />}
                onClick={() => {
                  navigateTo("/favorites");
                }}
              >
                {translator("Global.myFavorites")}
              </Button>
            </div>
          )}
          {isMobile && (
            <Menu>
              <MenuItem
                className="mobile-change-language"
                onClick={async () => {
                  onLanguageChange(baseLanguage === "es" ? "en" : "es");
                }}
              >
                <label>{baseLanguage.toUpperCase()}</label>
              </MenuItem>
            </Menu>
          )}
        </div>
      </header>
    )
  );
}
export default CCNavBar;
